import React, { useEffect, useState } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Snackbar, Alert } from '@mui/material';
import { Help } from '@mui/icons-material';
import { theme } from '../../../../../theme';

interface marketSalaryDataType {
    MarketDataNum: number | null,
    JobNum: number | null,
    JobTitle: string | null,
    MaximumSalary: number | null,
    MedianSalary: number | null,
    MinimumSalary: number | null
}

interface MarketDataProps {
    marketSalaryData: marketSalaryDataType | null
    handleUptoDateMarketData: () => void
    loading: boolean,
    marketJobTitle: string,
    readOnly: boolean
}

const MarketData: React.FC<MarketDataProps> = ({ marketSalaryData, handleUptoDateMarketData, loading, marketJobTitle, readOnly }) => {
    const formatSalary = (salay: number) => {
        return new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(salay)
    }


    return (

        <Box
            mb="1.6667vw" // Converted to vw
            sx={{

                margin: '0vw',
                display: 'flex',
                justifyContent: 'space-between',
                boxSizing: 'border-box',
            }}
        >
            <Box p="1.39vw 0" borderRadius="0.69vw" borderColor="divider" sx={{ width: '48%' }}>
                <Typography variant="h5">
                    Market Data (Import) <Help fontSize="small" color="primary"/>
                </Typography>

                <Button
                    variant="outlined"
                    sx={{
                        margin: '1.39vw',
                        marginLeft: 0,
                        mb: '0.5vw',
                        color: '#7F56D9',
                        backgroundColor: '#fff',
                        border: '0.07vw solid #7F56D9',
                    }}
                    color="primary"
                    onClick={() => { handleUptoDateMarketData() }}
                    disabled={loading}
                >
                    {loading ? 'Fetching Market Data...' : 'Import Industry Market Range Data'}
                </Button>


                <TableContainer component={Paper} sx={{ mt: '1.39vw' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{font:theme.typography.caption}}>Position</TableCell>
                                <TableCell sx={{font:theme.typography.caption}}>Min</TableCell>
                                <TableCell sx={{font:theme.typography.caption}}>Median</TableCell>
                                <TableCell sx={{font:theme.typography.caption}}>Max</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ backgroundColor: '#F9F5FF' }}>
                                <TableCell sx={{font:theme.typography.body1}}>{marketJobTitle || marketSalaryData?.JobTitle}</TableCell>
                                <TableCell sx={{font:theme.typography.body1}}>{marketSalaryData?.MinimumSalary ? marketSalaryData.MinimumSalary : '-'}</TableCell>
                                <TableCell sx={{font:theme.typography.body1}}>{marketSalaryData?.MedianSalary ? marketSalaryData.MedianSalary : '-'}</TableCell>
                                <TableCell sx={{font:theme.typography.body1}}>{marketSalaryData?.MaximumSalary ? marketSalaryData.MaximumSalary : '-'}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box p="1.39vw 0" borderRadius="0.69vw" borderColor="divider" sx={{ width: '48%' }}>
                <Typography variant="h5">
                    Market Data (Internal benchmark) <Help fontSize="small" color="primary"/>
                </Typography>

                <Button
                    variant="outlined"
                    sx={{
                        margin: '1.39vw',
                        marginLeft: 0,
                        mb: '0.5vw',
                        color: '#7F56D9',
                        backgroundColor: '#fff',
                        border: '0.07vw solid #7F56D9',
                    }}
                >
                    Get Internal Reference Point
                </Button>


                <TableContainer component={Paper} sx={{ mt: '1.39vw' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{font:theme.typography.caption}}>Position</TableCell>
                                <TableCell sx={{font:theme.typography.caption}}>Min</TableCell>
                                <TableCell sx={{font:theme.typography.caption}}>Median</TableCell>
                                <TableCell sx={{font:theme.typography.caption}}>Max</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ backgroundColor: '#F9F5FF' }}>
                                <TableCell sx={{font:theme.typography.body1}}>{marketJobTitle || marketSalaryData?.JobTitle}</TableCell>
                                <TableCell sx={{font:theme.typography.body1}}>-</TableCell>
                                <TableCell sx={{font:theme.typography.body1}}>-</TableCell>
                                <TableCell sx={{font:theme.typography.body1}}>-</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

export default MarketData;
